import { gql } from "@apollo/client";

import { PaginationResponse } from "@regal-voice/ui";

export type GetAiAgentsResponse = {
    getAiAgents: PaginationResponse<any>;
};

export const fetchAiAgents = gql`
    query ($queryParams: QueryParams!, $agentChannelType: String) {
        getAiAgents(queryParams: $queryParams, agentChannelType: $agentChannelType) {
            items {
                id
                name
                internalName
                imageUrl
                status
                version
                model
                voiceSettings
                language
                voiceTraits
                voiceName
                voiceProvider
                regalVoiceId
                agentType
                personalization
                actions
                dataExtractionSettings
                dataPoints {
                    id
                }
                callSettings
                keyMetrics
                taskSteps
                goal
                questionsAnswers
                greetingSettings
                friendlyId
                createdAt
                updatedAt
                createdBy
                updatedBy
                guardrails
                agentChannelType
                agentEmail
                variant {
                    id
                }
            }
            hasMore
        }
    }
`;
